function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaypal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ECE5DD"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9CBBD"
    },
    d: "M256,0c-11.317,0-22.461,0.744-33.391,2.167C348.216,18.53,445.217,125.933,445.217,256 s-97.002,237.47-222.609,253.833C233.539,511.256,244.683,512,256,512c141.385,0,256-114.616,256-256S397.385,0,256,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D81CE"
    },
    d: "M191.981,424.25c-1.142,0-2.008-1.03-1.813-2.155l41.147-236.597 c1.85-10.64,11.031-18.361,21.83-18.361h69.852c36.953,0,67.789,29.343,68.353,66.292c0.574,37.608-29.852,68.387-67.331,68.387 h-44.06l-22.676,120.934c-0.164,0.87-0.923,1.5-1.809,1.5H191.981z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#013F8A"
    },
    d: "M134.46,367.861c-1.156,0-2.032-1.042-1.834-2.182l41.143-236.571 c1.85-10.64,11.031-18.361,21.83-18.361h69.798c36.983,0,67.872,29.367,68.408,66.345c0.544,37.583-29.871,68.333-67.332,68.333 h-44.013c-0.027,0-0.05,0.019-0.055,0.046L199.74,366.343c-0.165,0.88-0.934,1.519-1.83,1.519h-63.45V367.861z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#003168"
    },
    d: "M222.218,246.467l9.098-60.969c1.85-10.638,11.03-18.361,21.83-18.361h70.874 c0.257,0,0.513,0.008,0.769,0.017l8.652,0.131l0.325,8.79c0.023,0.669,0.046,1.338,0.046,2.012c0,37.13-30.208,67.339-67.339,67.339 L222.218,246.467z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypal);
export default __webpack_public_path__ + "static/media/paypal.79ba0ae9d5500581b96a08451c739f5e.svg";
export { ForwardRef as ReactComponent };